var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1927,
    viewBox: "-2.2 0 402.1 311.7",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 314)",
    gradientUnits: "userSpaceOnUse",
    x1: 360.879,
    x2: 141.213,
    xlinkHref: "#a",
    y1: 351.455,
    y2: -69.294
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 314)",
    gradientUnits: "userSpaceOnUse",
    x1: 264.829,
    x2: 45.163,
    xlinkHref: "#a",
    y1: 401.601,
    y2: -19.148
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 314)",
    gradientUnits: "userSpaceOnUse",
    x1: 312.548,
    x2: 92.882,
    xlinkHref: "#a",
    y1: 376.688,
    y2: -44.061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8h-317.4c-5.8 0-8.7-7-4.6-11.1z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64.6 3.8c2.5-2.4 5.8-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8h-317.4c-5.8 0-8.7-7-4.6-11.1z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8h-317.4c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1z",
    fill: "url(#d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.889f3d16c586b343e06c7791b33c8845.svg";
export { ForwardRef as ReactComponent };